{
  "name": "iap-admin",
  "version": "1.2.6",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --hmr --port 4300",
    "generate-api": "openapi-generator-cli generate -g typescript-angular -i http://localhost:3003/openapi.json -o src/@backend -t generator-templates --additional-properties=queryParamObjectFormat=json",
    "build": "ng build",
    "build-dev": "ng build --configuration=dev",
    "build-uat": "ng build --configuration=uat",
    "build-prod": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "engines": {
    "node": "20 || 22"
  },
  "private": true,
  "dependencies": {
    "@adamsmid/datetime-picker": "^21.0.1",
    "@angular/animations": "^21.2.17",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@material-design-icons/svg": "^0.14.9",
    "@ngneat/until-destroy": "^10.0.0-beta.0",
    "@ngx-loading-bar/core": "^6.0.2",
    "@ngx-loading-bar/router": "^6.0.2",
    "@primeng/themes": "^19.1.3",
    "@tinymce/tinymce-angular": "^9.0.0",
    "@types/xlsx": "^0.0.36",
    "core-js": "^2.6.11",
    "highlight.js": "^11.8.0",
    "howler": "^2.2.3",
    "javascript-time-ago": "^2.5.9",
    "jwt-decode": "^4.0.0",
    "luxon": "~3.2.1",
    "moment": "^2.29.0",
    "ngx-mat-select-search": "^8.0.4",
    "ngx-quicklink": "^0.4.9",
    "primeng": "^21.0.2",
    "rxjs": "^7.4.0",
    "simplebar": "^6.2.5",
    "socket.io-client": "^4.8.1",
    "tailwindcss": "^3.4.17",
    "tinymce": "^7.9.1",
    "tslib": "^2.0.0",
    "xlsx": "^0.17.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.17",
    "@angular/cli": "^21.2.17",
    "@angular/compiler-cli": "^21.2.17",
    "@angular/localize": "^21.2.17",
    "@openapitools/openapi-generator-cli": "^2.13.4",
    "@types/jest": "^29.5.3",
    "@types/node": "^16.18.12",
    "@types/xlsx": "^0.0.36",
    "autoprefixer": "^10.4.14",
    "codelyzer": "^6.0.0",
    "path-browserify": "^1.0.1",
    "postcss": "^8.4.24",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "~5.9.3"
  }
}
